export { default } from './Score'
